/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Image, Segment, Button, Grid } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getNavigation } from '@plone/volto/actions';
import { asyncConnect } from '@plone/volto/helpers';
import LogoImage from '../Logo/itag_logo_new.png';
import { flattenToAppURL, addAppURL } from '@plone/volto/helpers/Url/Url';
import map from 'lodash/map';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { useSelector, shallowEqual } from 'react-redux';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import config from '@plone/volto/registry';
import 'remixicon/fonts/remixicon.css'

class Footer extends Component {
  /**
   * Property types.
   * @property {Object} propTypes Property types.
   * @static
   */
  static propTypes = {
    getNavigation: PropTypes.func.isRequired,
  };
  componentDidMount() {
      this.props.getNavigation('', 4);
  }
  renderItems = (items) => {
    return (
      <ul id="snd_column">
        {items.map((item) => (
          <li
            key={item.url}
            className={item.items?.length > 0 ? 'with-children' : ''}
          >
            <Link to={item.url}>{item.title}</Link>
            {/* {item.items && this.renderItems(item.items)} */}
          </li>
        ))}
      </ul>
    );
  };
  /**
   * Render method.
   * @method render
   * @returns {string} Markup for the component.
   */
  render() {
    const { items } = this.props;
    const year = new Date().getFullYear();
    const { settings } = config;
    return (
      <Segment
        role="contentinfo"
        vertical
        padded
        textAlign="center"
        id="footer"
        style={{ 'paddingTop': '5em' }}
      >
 <Container>
          <Grid stackable columns={3}>
            <Grid.Column width={4} style={{ 'textAlign': 'initial' }}>
              <p>
                <strong>
                  General inquiries
                  <br />
                </strong>
                Email: <a href='mailto:itag@myfwc.com'>itag@myfwc.com</a>
              </p>
              <br />
              <div>
                        <Image
                          src={LogoImage}
                          style={{
                            'float': 'inline-start',
                            'padding-right': '9px',
                            'height': '144px'
                          }}
                          title="iTAG"
                        />
                        <div style={{'padding-top': '8px'}}>
                        Integrated Tracking of Aquatic Animals in the Gulf
                        </div>
              </div>
              <br />
              <UniversalLink href="https://www.gcoos.org/" style={{'padding-top':'24px', 'float':'left'}}>
                        <Image
                          src={
                            settings.apiPath +
                            `/media/logos/gcoos.png/@@images/image/preview`
                          }
                          style={{
                            'marginLeft': 'auto',
                            'marginRight': 'auto',
                          }}
                          title="GCOOS"
                        />
                      </UniversalLink>
            </Grid.Column>
            <Grid.Column width={3} style={{ 'textAlign': 'initial' }}>
              <strong>Go to...</strong>
              {items && this.renderItems(items)}
            </Grid.Column>
            <Grid.Column width={4} style={{ 'textAlign': 'initial' }}>
              <Grid.Row style={{ 'marginBottom': '29.7px' }}>
                <Grid columns={4}>
                  <Grid.Column></Grid.Column>
                  <Grid.Column>
                    <a href="https://www.facebook.com/itagnetwork"
                       title="iTAG on Facebook">
                    <Button icon size='tiny' color='facebook'>
                      <i className="ri-facebook-line"></i>
                    </Button>
                    </a>
                  </Grid.Column>
                  <Grid.Column>
                    <a href="https://www.instagram.com/itag_science"
                       title="iTAG on Instagram">
                    <Button icon size='tiny' color='pink'>
                      <i className="ri-instagram-line"></i>
                    </Button>
                    </a>
                  </Grid.Column>
                  <Grid.Column></Grid.Column>
                </Grid>
              </Grid.Row>
              <Grid.Row style={{'padding-bottom': '12px'}}>
              <strong>Partners</strong>
              </Grid.Row>
              <Grid.Row>
                <Grid columns={2}>
                  <Grid.Column>
                    <div style={{ 'marginBottom': '29.7px', display: 'block' }}>
                      <UniversalLink href="https://myfwc.com/">
                        <Image
                          src={
                            settings.apiPath +
                            `/media/logos/fwc_logo.png/@@images/image/thumb`
                          }
                          style={{
                            'marginLeft': 'auto',
                            'marginRight': 'auto',
                          }}
                          title="Florida Fish and Wildlife Conservation Commission"
                        />
                      </UniversalLink>
                    </div>
                  </Grid.Column>
                  <Grid.Column>
                    <div style={{ display: 'block' }}>
                      <UniversalLink href="https://www.ufl.edu/">
                        <Image
                          src={
                            settings.apiPath +
                            `/media/logos/uf_logo.png/@@images/image/thumb`
                          }
                          style={{
                            'marginLeft': 'auto',
                            'marginRight': 'auto',
                          }}
                          title="University of Florida"
                        />
                      </UniversalLink>
                    </div>
                  </Grid.Column>
                </Grid>
              </Grid.Row>
              <Grid columns={2}>
              <Grid.Column>
                <div style={{ 'marginBottom': '29.7px', display: 'block' }}>
                  <UniversalLink href="http://noaa.gov/">
                    <Image
                      src={
                        settings.apiPath +
                        `/media/logos/noaa_logo.png/@@images/image/thumb`
                      }
                      style={{
                        'marginLeft': 'auto',
                        'marginRight': 'auto',
                      }}
                      title="NOAA"
                    />
                  </UniversalLink>
                </div>
              </Grid.Column>
              <Grid.Column>
                <div style={{ display: 'block' }}>
                  <UniversalLink href="https://oceantrack.org/">
                    <Image
                      src={
                        settings.apiPath +
                        `/media/logos/logo-full-white.png/@@images/image/mini`
                      }
                      style={{
                        'marginLeft': 'auto',
                        'marginRight': 'auto',
                      }}
                      title="Ocean Tracking Network"
                    />
                  </UniversalLink>
                </div>
              </Grid.Column>
              </Grid>
            </Grid.Column>
          </Grid>
          <div style={{ 'textAlign': 'initial' }}>
            Copyright © {year} University of Florida.
          </div>
        </Container>

      </Segment>
    );
  };
}

export default compose(
  connect(
    (state) => ({
      items: state.navigation.items,
    }),
    { getNavigation },
  ),
  asyncConnect([
    {
      key: 'navigation',
      promise: ({ location, store: { dispatch, getState } }) => {
        const { settings } = config;
        return __SERVER__ && dispatch(getNavigation('', 4));
      },
    },
  ]),
)(Footer);